import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useHistory } from "react-router-dom";
import Select from "react-select";
import "pages/style.css"
import Autocomplete from "react-autocomplete";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

export default withRouter(EditEvent)

registerLocale('ru', ru)

export function EditEvent() {
    let history = useHistory();
    const [date, setDate] = useState(null);
    const [items, setItems] = useState([]);
    const [item2, setItem2] = useState([]);
    const [selectedType, setSelectedType] = useState({ id: history.location.state.reqevent.typeid, value: history.location.state.reqevent.typename, label: history.location.state.reqevent.typename });
    const [selectedSubType, setSelectedSubType] = useState({ id: history.location.state.reqevent.typeid, value: history.location.state.reqevent.subtypename.String, label: history.location.state.reqevent.subtypename.String, link: history.location.state.reqevent.typename });
    const [selectedInpector, setSelectedInsp] = useState(null);
    const [autoitem, setAutoItem] = useState([]);
    const [name, setName] = useState([]);
    const [value, setValue] = useState(history.location.state.reqevent.value);
    const [filteredSubTypes, setfilteredSubType] = useState(null);
    const url2 = "/api/update/event"
    const url = "/api/get/subinfo"

    useEffect(() => {
        let unmounted = false;
        async function getD() {
            const resp = await axios.post(url);
            const responce = resp.data
            if (!unmounted) {
                setItems(
                    responce.types.map(item => ({ label: item.type, value: item.type, id: item.subtypes[0].id }))
                );
                var tmp = [];
                responce.types.map(item =>
                    Object.keys(item.subtypes).map((sub) => (item.subtypes[sub].subtype.String ? tmp.push({
                        id: item.subtypes[sub].id, label: item.subtypes[sub].subtype.String,
                        value: item.subtypes[sub].subtype.String, link: item.type
                    })
                        : {})))
                setItem2(tmp);
                setAutoItem(
                    responce.events.map((item) => ({ label: item }))
                );
                setName(
                    responce.inspectors.map((item) => ({ id: item.id, label: item.inspector }))
                );
            }
        }
        getD();
        return () => {
            unmounted = true;
        };
    }, []);
    const handleTypeChange = (selectedType) => {
        setSelectedType(selectedType)
        if (selectedType != null) {
            let fo = item2.filter(o => { return o.link.search(selectedType.label) !== -1; });
            setfilteredSubType(fo);
        }
        onClear();
    }

    const onClear = () => {
        setSelectedSubType(null)
    }
    const customStyle = {
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            padding: 5,
            backgroundColor: isFocused ? '#cae8a4' : null,
            color: isSelected ? '#000000' : '#000000'
        }),
        container: base => ({
            ...base,
            flex: 1,
            width: '30%',
        }),
        control: () => ({
            minHeight: '20px',
            height: '20px',
            width: '60%',
            border: '1px solid black',
            alignItems: 'center',
            display: 'flex',
            borderRadius: 3,
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        }
    }

    const menuStyle = {
        borderRadius: '3px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        background: 'rgba(255, 255, 255, 0.9)',
        padding: '2px 0',
        fontSize: '90%',
        position: 'fixed',
        overflow: 'auto',
        maxHeight: '50%',
        "zIndex": 100,
    };

    const handleSubmit = (e) => {
        let typeId = selectedSubType ? selectedSubType.id : selectedType.id;
        e.preventDefault();
        try {
            axios.post(url2, { id: history.location.state.reqevent.id, value: value, date: date, typeid: typeId, inspid: selectedInpector.id })
        } catch (error) {
            console.log(error)
        }
        history.goBack()
    }

    return (

        <div className="main">
            <h2>Изменить объект контроля</h2>
            <form onSubmit={handleSubmit}>
                Введите наименование объекта контроля:
                <br></br>
                <Autocomplete
                    shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item.label}
                    items={autoitem}
                    renderItem={(item, isHighlighted) =>
                        <div key={item.id}
                            style={{ background: isHighlighted ? '#cae8a4' : 'white', padding: 5, fontSize: '100%' }}>
                            {item.label}
                        </div>
                    }
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onSelect={(val) => setValue(val)}
                    menuStyle={menuStyle} />
                <br></br>
                <br></br>
                Выберите категорию:
                <br></br>
                <span className="dropdown-select">
                    <label>
                        <Select
                            value={selectedType}
                            defaultValue={selectedType}
                            onChange={handleTypeChange}
                            styles={customStyle}
                            options={items} />
                    </label>
                </span>
                <br></br>
                Выберите подкатегорию (при наличии):
                <br></br>
                <span className="dropdown-select">
                    <label>
                        <Select
                            value={selectedSubType}
                            defaultValue={selectedSubType}
                            onChange={setSelectedSubType}
                            styles={customStyle}
                            options={filteredSubTypes} />
                    </label>
                </span>
                <br></br>

                Выберите дату:
                <DatePicker
                    dateFormat="dd.MM.yyyy"
                    placeholderText='Дата'
                    locale={ru}
                    selected={date}
                    selectsStart
                    onChange={(date) => setDate(date)} />
                <br></br>
                <br></br>
                Выберите инспектора:
                <br></br>
                <span className="dropdown-select">
                    <label>
                        <Select
                            defaultValue={selectedInpector}
                            onChange={setSelectedInsp}
                            styles={customStyle}
                            options={name} />
                    </label>
                </span>
                <br></br>
                <input type={"submit"} value={"Отправить"} />
                <input type={"button"} value={"Назад"} onClick={history.goBack} />
            </form>
        </div>
    )
}
